export const environment = {
  production: true,
  apiUrl: 'https://opensandiego-voters-v-staging.herokuapp.com',
  gtm: 'GTM-5VP6C9W',
};
